import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { ZapierIcon } from '@mm/icons';
import SuppressionSettingsController from '@mm/state/controllers/SuppressionSettingsController';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import React from 'react';
import {
  errorToast,
  successToast,
} from '../../../../../../../../common/helpers/toast';
import { ReactComponent as CSVIcon } from 'assets/icons/csv-file.svg';
import { ReactComponent as GoogleIcon } from 'assets/icons/google-sheet.svg';
import css from './ContactSuppression.module.css';

export const ContactsSuppresstionsLists = ({
  data,
  onSuccess,
}: {
  data: any[];
  onSuccess: () => void;
}) => {
  const { openNewConfirmModal, closeModal } = useModalActions();

  const getClassNameByType = s => {
    switch (s) {
      case 'google_sheet':
        return css.google;
      case 'csv_file':
        return css.csv;
      case 'zapier':
        return 'zapier';
      default:
        return '';
    }
  };

  const getIconByType = s => {
    switch (s) {
      case 'google_sheet':
        return <GoogleIcon />;
      case 'csv_file':
        return <CSVIcon />;
      case 'zapier':
        return <ZapierIcon />;
      default:
        return <></>;
    }
  };

  const handleCSVDelete = async csv => {
    try {
      await SuppressionSettingsController.deleteCSV(csv.id);
      successToast('CSV removed');
      await onSuccess();
    } catch (err) {
      errorToast(`Error removing csv`, 'top-right');
    }
  };

  const handleCsvDeleteClick = value => {
    openNewConfirmModal({
      title: `List of emails and domains`,
      subtitle: `Are you sure you want to remove "${value.name}"?`,
      onResolve: async () => {
        await handleCSVDelete(value);
        closeModal();
      },
      onReject: closeModal,
    });
  };

  return (
    <div className={css.list}>
      {data.map(item => (
        <div className={css.listItem} key={item.id}>
          <div
            className={classNames(css.listIcon, {
              [getClassNameByType(item.type)]: !!item.type,
            })}
          >
            {getIconByType(item.type)}
          </div>
          <span className={css.listTitle}>{item.name}</span>
          {item.processed ? (
            <span className={css.listCount}>{item.count}</span>
          ) : (
            <Tooltip
              title="There was an issue accessing the file. Please reconnect to try
            again."
            >
              <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />
            </Tooltip>
          )}
          <span className={css.listActions}>
            <div className={css.listAction}>
              <div
                className={css.listActionIcon}
                onClick={() => handleCsvDeleteClick(item)}
              >
                <DeleteOutlined />
              </div>
            </div>
          </span>
        </div>
      ))}
    </div>
  );
};
